module.exports = __webpack_public_path__ + "img/Logo_Oney_RGB_verde.6d3d2421.svg";